<template>
  <div id="view">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <!-- 列表 -->
      <div class="bannerList" v-show="pageShow == 'index'">
        <!-- 顶部起始位置 -->
        <div class="topBox flex">
          <ul class="flex">
            <li class="flex">
              <div style="width: 240px">
                <el-input v-model="searchVle" placeholder="请输入品牌名称"></el-input>
              </div>
            </li>
            <li class="flex" style="margin-left:15px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>
            </li>
          </ul>
        </div>
        <!-- 顶部结束位置 -->

        <div class="table-scroll-wrap">
          <el-table border :data="tableData" style="width: 100%">
            <!-- <el-table-column prop="id" align="center" label="ID" width="80">
            </el-table-column> -->
            <el-table-column prop="nickName" align="center" label="查询用户">
            </el-table-column>
            <el-table-column prop="brandName" align="center" label="品牌名称">
            </el-table-column>
            <el-table-column prop="batchNumber" align="center" label="批号">
            </el-table-column>

            <!-- <el-table-column align="center" label="状态" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.status == 0 ? '待处理' : scope.row.status == 1 ? '已处理' : '未知' }}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="createTime" align="center" label="查询时间" width="180">
            </el-table-column>
            <el-table-column align="center" label="操作" width="180">
              <template slot-scope="scope">
                <!-- <el-button type="success" size="small" @click="viewFn(scope.$index)">查看</el-button> -->
                <el-button type="danger" size="small" @click="delFn(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <list-pagination
          :total="tableTotal"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @page-change="changePage"
          @size-change="handlePageSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { delTips, throttle, returnTime } from "@/util/utils";
export default {
  data() {
    return {
      // 历史记录
      historyArr: ["批号查询管理", "无品牌逻辑查询记录"],

      // 搜索
      searchVle: "",

      currentPage: 1,
      pageSize: 50,
      tableTotal: 0,
      pageShow: "index",
      tableData: [],
    };
  },
  created() { },
  mounted() {
    this.selListFn(1); //查询
  },
  methods: {
    // 分页
    changePage: function (page) {
      this.selListFn(page)
    },

    handlePageSizeChange() {
      this.selListFn(this.currentPage);
    },

    // 搜索
    searchFn: function (res) {
      this.selListFn(1)
    },

    // 查询
    selListFn: function (page) {
      if (page) {
        this.currentPage = page;
      }
      var obj = {
        page: this.currentPage || 1,
        size: this.pageSize
      };

      if (this.searchVle) {
        obj.brandName = this.searchVle
      }

      this.$https(this.$api.api.selUserNoBrandBatchCalLogic, obj, "GET").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data || [];
          // 格式化时间
          data.forEach((v) => {
            if (v.createTime) {
              v.createTime = returnTime(new Date(v.createTime), "-", "s");
            }
            if (v.updateTime) {
              v.updateTime = returnTime(new Date(v.updateTime), "-", "s");
            }
          });
          this.tableData = data;
          this.tableTotal = res.data.size || 0;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
          this.$message.error(res.data.msg || "查询失败");
        }
      });
    },

    // 查看
    viewFn: function (index) {
      var list = this.tableData[index];
      // TODO: 实现查看详情功能
      this.$message.info("查看功能待实现");
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];
      // TODO: 替换为实际的API接口
      // this.$https(
      //   this.$api.api.delNoBrandQueryRecord,
      //   {
      //     id: list.id,
      //   },
      //   "GET"
      // ).then((res) => {
      //   if (res.data.code == 200) {
      //     this.$message.success("操作成功");
      //     this.selListFn(this.currentPage)
      //   } else {
      //     this.$message.error("操作失败");
      //   }
      // });
    }),
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;

  // 头部
  .topBox {
    width: 100%;
    margin-bottom: 10px;
    text-align: right;
    justify-content: space-between;
  }

  .bannerList {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/batchQuery/noBrandQueryRecord.vue